import html2canvas from 'html2canvas';

export default {
  init() {
    // JavaScript to be fired on the Pledge page
    $('.passcontainer').hide();

    $('.pledgeInit').click(function () {
      $('.passcontainer').fadeIn();

      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top,
        },
        800
      );
    });

    $('#generate').on('click', function () {
      html2canvas($('#pledge'), {
        onrendered: function (canvas) {
          // canvas is the final rendered <canvas> element
          var myImage = canvas.toDataURL('image/jpg', 1);
          // window.open(myImage);

          $('.lightbox').fadeIn(200);
          $('.bgOverlay').fadeIn(200);
          $('.image').attr('src', myImage).fadeIn(200);
          $('.link').attr('href', myImage).fadeIn(200);
        },
      });
    });

    $('.lightbox').on('click', function () {
      $('.bgOverlay').fadeOut('fast');
      $('.lightbox').fadeOut('fast');
    });
  },
  finalize() {
    // JavaScript to be fired on the Pledge page, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pledge.js